(() => {
'use strict';
const mobile=matchMedia('(max-width:749px)').matches;
const node=document.querySelector(mobile?'[data-sl-mobile-frames]':'[data-sl-frames]');
if(!node||!window.SLFrameCache)return;
let urls=JSON.parse(node.textContent||'[]');
// 60 views at 640 px on phones; keep all 120 original views on desktop.
if(mobile)urls=urls.filter((_,i)=>i%2===0).map(value=>value.replace('_960x.webp','_640x.webp'));
const count=urls.length;if(!count)return;
const cache=window.SLFrameCache(urls,{mobileStable:mobile,wrap:true,anchor:!mobile,decodeLimit:mobile?16:10,decodeAhead:8,prefetch:mobile?12:24,blobLimit:48,concurrency:3});
const wrap=i=>((Math.round(i)%count)+count)%count;
function peek(index){index=wrap(index);if(cache.ready.has(index)){cache.touch?.(index);return cache.ready.get(index);}
let closest=null,best=count;for(const frame of cache.ready.values()){const d=Math.min(Math.abs(frame.index-index),count-Math.abs(frame.index-index));if(d<best){best=d;closest=frame;}}if(closest)cache.touch?.(closest.index);return closest;}
window.BeamSequence={count,url:i=>urls[wrap(i)],start:()=>cache.start(),prepare:i=>cache.prepare(wrap(i)),peek,
pause:()=>cache.pause(),destroy:()=>cache.destroy(),subscribe:fn=>cache.subscribe(fn),retry:()=>cache.retry(),
get:i=>{cache.prepare(wrap(i));return Promise.resolve(peek(i));},get available(){return cache.stats.available;},
get complete(){return cache.stats.available===count;},get failed(){return cache.failed;},get stats(){return {...cache.stats,mobile};}};
})();

